import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/Button/Button'
import {
  PaytrieTopIcon,
  PoweredByLabel,
  LoginHeader,
} from '@/components/widget-components'
import { Pages, usePageStateStore } from '@/reducers'
import { Stepper } from '@/pages/Signup/Stepper/Stepper'

export const RegistrationFailure = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const returnToHome = () => {
    navigate('/EasyLogin')
  }

  return (
    <div
      className="flex flex-col md:flex-row"
      data-testid="container-registration-failure"
    >
      <LoginHeader data-testid="container-registration-failure-header">
        <Stepper />
      </LoginHeader>
      <div
        className="relative p-5 lg:py-20 w-full"
        data-testid="container-registration-failure-content"
      >
        <PaytrieTopIcon
          className="absolute top-5 right-5 hidden md:block"
          data-testid="icon-registration-failure-logo"
        />
        <div
          className="flex-grow mb-5"
          data-testid="container-registration-failure-message"
        >
          <div className="flex flex-col gap-5">
            <div
              className="text-2xl font-normal uppercase"
              data-testid="text-registration-failure-heading"
            >
              {t('registrationFailure.heading')}
            </div>
            <br />
            <div data-testid="text-registration-failure-message">
              {t('registrationFailure.message')}
            </div>
            <br />
            <br />
            <br />
            <Button
              onClick={returnToHome}
              data-testid="btn-registration-failure-home"
            >
              {t('registrationFailure.returnHome')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
